import React from 'react';
import { AppBar, Toolbar, IconButton, Typography, Box } from '@mui/material';
import { ArrowBack as ArrowBackIcon } from '@mui/icons-material';

interface AppHeaderProps {
  title: string;
  onBack?: () => void;
  rightAction?: React.ReactNode;
}

/**
 * AppHeader — Flutter-native style.
 * Matches CustomAppBar in Flutter: white/transparent bg, no elevation,
 * title left-aligned (Flutter default centerTitle: false), dark text.
 */
export const AppHeader: React.FC<AppHeaderProps> = ({ title, onBack, rightAction }) => {
  return (
    <AppBar
      position="static"
      elevation={0}
      sx={{
        backgroundColor: 'background.paper',
        color: 'text.primary',
        borderBottom: '1px solid',
        borderColor: 'divider',
      }}
    >
      <Toolbar
        sx={{
          minHeight: '56px !important',
          px: 1,
          gap: 0.5,
        }}
      >
        {onBack && (
          <IconButton
            edge="start"
            onClick={onBack}
            sx={{
              width: 40,
              height: 40,
              color: 'text.primary',
            }}
          >
            <ArrowBackIcon sx={{ fontSize: 20 }} />
          </IconButton>
        )}

        <Typography
          variant="h5"
          component="h1"
          sx={{
            flex: 1,
            fontSize: '1rem',
            fontWeight: 600,
            color: 'text.primary',
            pl: onBack ? 0 : 1,
          }}
        >
          {title}
        </Typography>

        {rightAction ? (
          <Box sx={{ ml: 0.5 }}>{rightAction}</Box>
        ) : onBack ? (
          <Box sx={{ width: 40 }} />
        ) : null}
      </Toolbar>
    </AppBar>
  );
};
